module.exports = __webpack_public_path__ + "ghana.svg?4ebd0391ed8bbab5e56b4278112c071c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/ghana.svg
// module id = 174
// module chunks = 10